import * as React from "react";
export function SvgDataCatalogLineageTableWhite(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M19 6H5c-.5 0-1 .5-1 1v11c0 .6.5 1 1 1h14c.5 0 1-.4 1-1V7c0-.5-.5-1-1-1zM9 18H5v-2h4v2zm0-3H5v-2h4v2zm0-3H5v-2h4v2zm5 6h-4v-2h4v2zm0-3h-4v-2h4v2zm0-3h-4v-2h4v2zm5 6h-4v-2h4v2zm0-3h-4v-2h4v2zm0-3h-4v-2h4v2zm0-3H5V7h14v2z"
        fill="#fff"
      />
    </svg>
  );
}
